<button
    [ngStyle]="{
        fontSize: customFontSize,
        color: customFontColor,
        fontWeight: customFontWeight,
        fontFamily: customFontFamily,
    }"
    [ngClass]="[size, variant]"
    [class.padding]="!noneButtonPadding"
    [class.hover]="noneHover"
    [class.disabled]="disable"
    [style.borderColor]="customBorderColor"
    [type]="type"
    data-cy="generic-button"
    (click)="buttonClick($event)">
    <mat-icon
        class="icon"
        [svgIcon]="icon"
        [class.show]="iconButton"
        [class.margin]="!noneMarginIcon"
        [style.width]="iconSize"
        [style.height]="iconSize"></mat-icon>
    <ng-container>
        {{ text | translate: translateParams }}
    </ng-container>
</button>
